import React from 'react';

const LoadingSkeleton = () => (
  <div className="loading-skeleton">
    <div className="skeleton-line"></div>
    <div className="skeleton-line"></div>
    <div className="skeleton-line"></div>
  </div>
);

export default LoadingSkeleton;

